// Carte du site : une seule source pour le méga-menu et le footer.
// Toute entrée listée ici DOIT pointer vers une page réelle (aucun lien mort).

export const MEGA = [
  {
    label: "Plateforme",
    groups: [
      {
        title: "Coaching",
        items: [
          { icon: "Users", label: "Le coach", desc: "Qui vous accompagne, et comment", to: "/coach" },
          { icon: "Video", label: "Analyse de VOD", desc: "Vos parties décortiquées image par image", to: "/fonctionnalites/analyse-video" },
        ],
      },
      {
        title: "En séance",
        items: [
          { icon: "Radio", label: "Coaching live", desc: "Salle de session, écran partagé, notes", to: "/fonctionnalites/coaching-live" },
          { icon: "Sparkles", label: "Perform AI", desc: "Votre analyste entre deux séances", to: "/fonctionnalites/perform-ai" },
        ],
      },
      {
        title: "Matériel",
        items: [
          { icon: "Gamepad2", label: "Custom", desc: "Manettes et consoles personnalisées", to: "/custom" },
          { icon: "Target", label: "Cotisation", desc: "Abonnement mensuel de coaching", to: "/cotisation" },
        ],
      },
      {
        title: "Découvrir",
        items: [
          { icon: "Target", label: "Smart Match", desc: "Le bon coach en trois questions", to: "/fonctionnalites/smart-match" },
          { icon: "Gamepad2", label: "Les jeux", desc: "Les cinq jeux suivis", to: "/games" },
        ],
      },
    ],
    aside: {
      title: "Commencer",
      items: [
        { label: "Tarifs", to: "/tarifs" },
        { label: "Cotisation", to: "/cotisation" },
        { label: "Custom", to: "/custom" },
        { label: "Programme partenaire", to: "/partenaires" },
        { label: "Nous contacter", to: "/contact" },
      ],
    },
  },
  {
    label: "Ressources",
    groups: [
      {
        title: "Apprendre",
        items: [
          { icon: "LifeBuoy", label: "Centre d'aide", desc: "Réponses aux questions courantes", to: "/aide" },
          { icon: "BookOpen", label: "Documentation", desc: "Comment fonctionne Perform", to: "/docs" },
        ],
      },
      {
        title: "Construire",
        items: [
          { icon: "Code2", label: "Développeurs", desc: "API HTTP et webhooks", to: "/developpeurs" },
          { icon: "Activity", label: "État des services", desc: "Disponibilité en temps réel", to: "/statut" },
        ],
      },
      {
        title: "Confiance",
        items: [
          { icon: "ShieldCheck", label: "Trust Center", desc: "Sécurité, données, conformité", to: "/trust-center" },
          { icon: "GitCommitHorizontal", label: "Nouveautés", desc: "Ce que nous livrons, semaine après semaine", to: "/nouveautes" },
        ],
      },
    ],
    aside: {
      title: "L'entreprise",
      items: [
        { label: "À propos", to: "/a-propos" },
        { label: "Manifeste", to: "/manifeste" },
        { label: "Témoignages", to: "/temoignages" },
        { label: "Carrières", to: "/carrieres" },
      ],
    },
  },
];

// Liens simples de la barre de navigation, après les menus déroulants.
export const NAV_FLAT = [
  { label: "Le coach", to: "/coach" },
  { label: "Tarifs", to: "/tarifs" },
  { label: "Custom", to: "/custom" },
];

// Compte des liens du footer, utilisé par les tests de non-régression.
export const footerLinkCount = () => FOOTER.reduce((n, c) => n + c.links.length, 0);

export const GAMES_STRIP = [
  { label: "League of Legends", slug: "league-of-legends" },
  { label: "Counter-Strike 2", slug: "counter-strike-2" },
  { label: "Call of Duty", slug: "call-of-duty" },
  { label: "Fortnite", slug: "fortnite" },
  { label: "EA FC", slug: "ea-fc" },
];

export const FOOTER = [
  {
    title: "Produit",
    links: [
      { label: "Fonctionnalités", to: "/fonctionnalites" },
      { label: "Tarifs", to: "/tarifs" },
      { label: "Cotisation", to: "/cotisation" },
      { label: "Custom", to: "/custom", badge: "Nouveau" },
      { label: "Nouveautés", to: "/nouveautes" },
      { label: "Feuille de route", to: "/roadmap" },
      { label: "Intégrations", to: "/integrations" },
      { label: "API", to: "/developpeurs" },
      { label: "Sécurité", to: "/securite" },
    ],
  },
  {
    title: "Pour qui",
    links: [
      { label: "Joueurs", to: "/pour/joueurs" },
      { label: "Équipes et clubs", to: "/pour/equipes" },
      { label: "Le coach", to: "/coach" },
      { label: "Méthode", to: "/coach#methode" },
      { label: "Manettes Custom", to: "/custom" },
    ],
  },
  {
    title: "Ressources",
    links: [
      { label: "Documentation", to: "/docs" },
      { label: "Centre d'aide", to: "/aide" },
      { label: "Guides", to: "/guides" },
      { label: "Communauté", to: "/communaute" },
      { label: "Témoignages", to: "/temoignages" },
      { label: "Découvrir", to: "/discover" },
    ],
  },
  {
    title: "Entreprise",
    links: [
      { label: "À propos", to: "/a-propos" },
      { label: "Manifeste", to: "/manifeste" },
      { label: "Carrières", to: "/carrieres" },
      { label: "Presse", to: "/presse" },
      { label: "Partenaires", to: "/partenaires" },
      { label: "Experts", to: "/experts" },
      { label: "Contact", to: "/contact" },
    ],
  },
  {
    title: "Confiance",
    links: [
      { label: "Trust Center", to: "/trust-center" },
      { label: "Sécurité", to: "/securite" },
      { label: "Conformité", to: "/conformite" },
      { label: "Confidentialité", to: "/confidentialite" },
      { label: "Sous-traitants", to: "/legal/sous-traitants" },
      { label: "Signaler une faille", to: "/securite/divulgation" },
      { label: "État des services", to: "/statut" },
    ],
  },
  {
    title: "Développeurs",
    links: [
      { label: "Documentation API", to: "/docs/api/authentification" },
      { label: "Référence des endpoints", to: "/docs/api/reference" },
      { label: "Erreurs", to: "/docs/api/erreurs" },
      { label: "Limites de débit", to: "/docs/api/limites" },
      { label: "Espace développeur", to: "/developpeurs" },
      { label: "Transparence IA", to: "/ia" },
    ],
  },
  {
    title: "Légal",
    links: [
      { label: "Tous les documents", to: "/legal" },
      { label: "Conditions générales", to: "/legal/cgu" },
      { label: "Confidentialité", to: "/legal/confidentialite" },
      { label: "Cookies", to: "/legal/cookies" },
      { label: "Usage acceptable", to: "/legal/usage-acceptable" },
      { label: "Traitement des données", to: "/legal/dpa" },
      { label: "Conditions IA", to: "/legal/conditions-ia" },
      { label: "Annulation et remboursement", to: "/legal/annulation" },
      { label: "Mentions légales", to: "/legal/mentions" },
    ],
  },
];

// Barre du bas : liens essentiels, toujours visibles.
export const FOOTER_BOTTOM = [
  { label: "Confidentialité", to: "/legal/confidentialite" },
  { label: "Conditions", to: "/legal/cgu" },
  { label: "Cookies", to: "/legal/cookies" },
  { label: "Sécurité", to: "/securite" },
  { label: "État des services", to: "/statut" },
];

// Signaux de confiance. Uniquement des mesures réellement en place :
// aucune certification n'est revendiquée tant qu'elle n'est pas obtenue.
export const TRUST_BADGES = [
  { icon: "Lock", label: "TLS 1.3 de bout en bout", to: "/securite#chiffrement" },
  { icon: "KeyRound", label: "Connexion sans mot de passe", to: "/securite#authentification" },
  { icon: "ShieldCheck", label: "RGPD — droits exerçables", to: "/confidentialite" },
  { icon: "Activity", label: "État des services public", to: "/statut" },
];
